<script>
  import Button from '@ui/pico/button.svelte';
  import Toggle from '@ui/pico/toggle.svelte';
  import { onMount } from 'svelte';

  import { handleRedirect, pages } from '../../config';
  import { exitIfEscape, goto } from '../../util';
  import { createSite, getBalance, getSites } from '../../services';

  let el;
  let terms = false;
  let website = '';
  let formattedBalance = '$0';

  export let params;

  $: siteParts = website?.split('.');
  $: websiteValid = siteParts.length > 1 && siteParts?.at(-1).length >= 2;
  $: buttonActive = websiteValid && terms;

  onMount(async () => {
    el?.focus();

    const noSites = ((await getSites()) || [])?.length === 0;
    if (noSites) {
      goto(pages.sites.first.url);
      return;
    }

    const bal = await getBalance();
    formattedBalance = bal.usd;
  });

  async function requestSiteCreation() {
    try {
      const siteResult = await createSite({ domain: website });
      if (siteResult.status < 400) {
        backToAccount();
      }
    } catch (error) {
      console.info({ error, website });
    }
  }
  function backToAccount() {
    goto(pages.account.list.url);
  }
</script>

<svelte:window on:keyup={exitIfEscape(pages.account.list.url)} />

<dialog open>
  <article>
    <header>
      <a
        on:click|preventDefault={backToAccount}
        href="#close"
        aria-label="Close"
        class="close">&nbsp;</a
      >
    </header>
    <form on:submit|preventDefault={requestSiteCreation}>
      <hgroup>
        <h2>Add a Site</h2>
        <h4>Total available funds {formattedBalance}</h4>
      </hgroup>

      <div class="grid">
        <div>
          <input
            bind:this={el}
            bind:value={website}
            required
            type="text"
            placeholder="yourwebsite.com"
          />
          <Toggle bind:value={terms} class="toggle secondary">
            Agree to monthly credit deduction of $1
          </Toggle>
        </div>
      </div>
      <Button
        disabled={!buttonActive}
        type="submit"
        class={buttonActive ? 'primary' : 'secondary'}
        iconLeft="upload-cloud"
        iconSize={32}>Purchase Site</Button
      >
    </form>
  </article>
</dialog>

<style>
  :global(.toggle) {
    --switch-checked-background-color: var(--primary);
  }
  article {
    width: 80vw;
    max-width: 700px;
  }
  article header {
    margin-bottom: 1em;
  }

  :global(button svg) {
    stroke-width: 1.6px;
  }
</style>
